import React from 'react'
import { Pie } from 'react-chartjs-2'
import { ChartQuestionOption, respondPercentage, ChartData } from 'hooks/reports'
import { shade } from 'resources/helpers'
import { livBriteTheme } from 'app/livbrite/resources/theme'

interface Props {
  options: ChartQuestionOption[]
  totalResponses: number
}

export const PieChart = ({ options, totalResponses }: Props) => {
  const data = options.reduce((obj: ChartData, option: ChartQuestionOption, i: number) => {
    if (option.parent_id < 1) {
      obj.labels.push(option.option_label)
      obj.datasets[0].data.push(option.selected_by)
      obj.datasets[0].backgroundColor.push(shade(livBriteTheme.palette.primary.alphaDark, (i / 10)))
    }
    return obj
  }, { labels: [], datasets: [{ label: '# of Responses', data: [], backgroundColor: [], borderColor: [], borderWidth: 0 }] })

  const configOptions = {
    scaleShowLabels: false,
    hoverOffset: 10,
    offset: 5,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true
      },
      tooltip: {
        backgroundColor: livBriteTheme.palette.general.light,
        titleColor: livBriteTheme.palette.primary.alphaDark,
        titleFont: { weight: 'normal', size: 14 },
        bodyFont: { weight: 'bold', size: 14 },
        footerColor: livBriteTheme.palette.primary.alphaDark,
        bodyColor: livBriteTheme.palette.primary.alphaDark,
        displayColors: false,
        callbacks: {
          label: function (context: any) {
            const value = context.parsed
            const percentage = `${respondPercentage(value, totalResponses)}%`
            const label = `${percentage}, ${value} ${value < 2 ? 'Response' : 'Responses'}`

            return label
          },
          title: function (context: any[]) {
            const label = context[0].label

            return label
          }
        }
      }
    }
  }

  return (
    <>
      <Pie data={data} type='pie' options={configOptions} />
    </>
  )
}
